import JobSearch from "@sourceflow-uk/job-search";
import { Container, Row, Col, Card } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import Arrow from "/public/site-assets/svg/black-arrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import useJobs from "@/hooks/useJobs";
import { useRouter } from "next/router";
import JobCard from '../../components/JobCard';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

export const LatestJobsCarousel = ({
  className,
  title,
  heading,
  content,
  jobSearch,
  buttonLink,
  buttonTitle,
  buttonStyling,
  specialisms,
  sectors,
  employers,
  filterSectors,
  filterRegions,
  filterJobTypes,
  limit
}) => {
  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  const items = useJobs({
    locale,
    filters: locale == "/us/" ? sectors : specialisms,
    employers,
    regionFilters: filterRegions,
    sectorFilters: filterSectors,
    jobTypesFilters: filterJobTypes,
    limit
  });

  if (!items || !items.length > 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .latestJobsSwiper`,
    },
    navigation: {
      nextEl: `.latestJobsSwiper.swiper-next`,
      prevEl: `.latestJobsSwiper.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <Row className="mb-4">
          <div className="text-center">
            {title && (
              <h2 className={`text-primary-color ${heading}`}>
                {title}
              </h2>
            )}
            {content && (
              <div
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        </Row>
        {jobSearch && (
          <div className="d-flex swiperArrowWrapper justify-content-end mb-4">
            <button
              className="latestJobsSwiper arrow swiper-prev border-0 p-0"
              aria-label="Prev"
            >
              <Arrow />
            </button>
            <button
              className="latestJobsSwiper arrow swiper-next border-0 ms-2 p-0"
              aria-label="Next"
            >
              <Arrow />
            </button>
          </div>
        )}
        <Swiper {...settings}>
          {items?.map((job, index) => (
            <SwiperSlide key={index}>
              <JobCard
                {...job}
                post_lang={locale}
                slider={true}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="text-center swiper-custom-paginations mt-4">
          <div className="latestJobsSwiper" />
        </div>

        {buttonLink && buttonTitle &&
          <div className="text-center mt-4">
            <Link href={buttonLink}>
              <a className={buttonStyling || "primaryBtn arrow m-0"}>
                {buttonTitle}
              </a>
            </Link>
          </div>
        }
      </Container>
    </section>
  );
};

export default LatestJobsCarousel;
